
export default {
    category3Code: [
        { required: true, message: '请选择Category3', trigger: 'change' }
    ],
    aslGroupCode: [
        { required: true, message: '请选择ASL Group', trigger: 'change' }
    ],
    medicineLevelOneGrade: [
        { required: true, message: '请选择药品一级分类', trigger: 'change' }
    ],
    medicineLevelTwoGrade: [
        { required: true, message: '请选择药品二级分类', trigger: 'change' }
    ],
    whoMedicineGrade: [
        { required: true, message: '请选择WHO药品等级', trigger: 'change' }
    ],
    oieMedicineGrade: [
        { required: true, message: '请选择OIE药物等级', trigger: 'change' }
    ],
    effectiveComponents: [
        { required: true, message: '请选择有效成分', trigger: 'change' }
    ],
    commonName: [
        { required: true, message: '请输入通用名', trigger: 'blur' }
    ],
    productName: [
        { required: true, message: '请输入商品名', trigger: 'blur' }
    ],
    approvelNumber: [
        { required: true, message: '请输入兽药批准文号', trigger: 'blur' }
    ],
    lastDetectionTime: [
        { required: true, message: '请选择最新检测时间', trigger: 'change' }
    ],
    effectiveComponentsContent: [
        { required: true, message: '请输入有效成分和含量', trigger: 'blur' }
    ],
    effectiveComponentsOther: [
        { required: true, message: '请输入有效成分其他', trigger: 'blur' }
    ],
    indication: [
        { required: true, message: '请输入适应症', trigger: 'blur' }
    ],
    producer: [
        { required: true, message: '请输入生产厂家', trigger: 'blur' }
    ],
    specification: [
        { required: true, message: '请输入规格', trigger: 'blur' }
    ],
    usage: [
        { required: true, message: '请输入用法和用量', trigger: 'blur' }
    ],
    withdrawalDay: [
        { required: true, message: '请输入休药期', trigger: 'blur' }
    ],
    astDetectionTime: [
        { required: true, message: '请输入最新检测时间', trigger: 'blur' }
    ],
    medicineUseStatus: [
        { required: true, message: '请选择药品在用状态', trigger: 'change' }
    ],
    breedingMode: [
        { required: true, message: '请选择养殖模式', trigger: 'change' }
    ],
    aslGroup: [
        { required: true, message: '请选择ASL Group', trigger: 'change' }
    ],
    // modifyReason: [
    //     { required: true, message: '请输入修改原因', trigger: 'blur' }
    // ],
}